import React from "react"
import Grid from "@mui/material/Grid"
import EmptyState from "components/atoms/EmptyState"
import WishListSummaryCard from "components/molecules/WishListSummaryCard"
import LoadingPlaceholder from "components/templates/WishListsList/LoadingPlaceholder"

type ListsProps = {
  loading: boolean;
  lists: WishList[];
  privacyOptionDetails: Map<any, any>;
  handleMoreButtonClicked: (list: WishList) => void;
}

export default function Lists(props: ListsProps) {
  const { loading, lists, handleMoreButtonClicked, privacyOptionDetails } = props

  return (
    <>
      {!loading ? <>
        {lists?.length ? <Grid container spacing={7} flexGrow={1}>
          {lists?.map((list: WishList) => (
            <Grid key={list.id} item xs={6}>
              <WishListSummaryCard
                key={list.id}
                listInfo={list}
                onMoreButtonClicked={handleMoreButtonClicked}
                privacyOptionDetail={privacyOptionDetails.get(list.privacy)}
              />
            </Grid>
          ))}
        </Grid> : <EmptyState/>}
      </> : <LoadingPlaceholder/>}
    </>
  )
}
